export const BuildInfo = {timestamp:1776374716000}
